import { EngagementPoint } from 'types/chartTypes';

export const formatDate = (dateString: string) => {
  // Input: 2023-12-01
  const date = new Date(dateString);

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric', // '2023'
    month: 'short', // 'Dec'
    day: 'numeric', // '1'
  }).format(date);
}; // Output: Dec 1, 2023

export const transformTopEngagedChartsData = (inputArray: EngagementPoint[]) => {
  return inputArray.map((item) => {
    const transformedSegments = item.journeyStages.map((stage) => {
      return {
        name: stage.stage,
        value: stage.engagementMinutes,
      };
    });

    return {
      category: item.name,
      segments: transformedSegments,
    };
  });
};
